function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M256 512c141 0 256-115 256-256S397 0 256 0 0 115 0 256s115 256 256 256zm-43-262c0-23 19-42 43-42s43 19 43 42v114c0 24-19 43-43 43s-43-19-43-43zm0-122c0-24 19-43 43-43s43 19 43 43-19 43-43 43-43-19-43-43z"
})));